import { TableData } from './table-data';

export class ColumnSet {
  id?: string;
  selected_columns?: Column[];
  all_columns?: Column[];
  validated_df?: TableData;
}

export class Column {
  id?: number;
  type?: number;
  name?: string;
  selected_by_ai?: boolean;

  constructor(
    id: number | undefined,
    type: number,
    name: string,
    selected_by_ai: boolean
  ) {
    this.id = id;
    this.type = type;
    this.name = name;
    this.selected_by_ai = selected_by_ai;
  }
}
